module.exports = __webpack_public_path__ + "static/car-pc/img/ding.cec76b4d.svg";